import API from '@/shared/plugins/Api/API'

class SshV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  async getPublicKey () {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/ssh/public-key`
    })
    return response?.public ?? response
  }
}

export default SshV3
